import { render, staticRenderFns } from "./UpdateRoles.vue?vue&type=template&id=356b129e&scoped=true&"
import script from "./UpdateRoles.vue?vue&type=script&lang=js&"
export * from "./UpdateRoles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356b129e",
  null
  
)

export default component.exports